import { maskedMobilePhone } from '@euler/app/tv/functions/maskedMobilePhone';
import { Icon } from '@euler/components/Icomoon';
import { Input } from '@euler/components/form/Input';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useUserPermissions } from '@euler/functions/user/useUserPermissions';
import { usePersistFn } from '@euler/utils/hooks';
import { memo, useRef, useState } from 'react';
import { useOrderFlowContext } from '../../../../OrderFlowContext';
import { Cell } from '../components/Cell';
import { IconWrapper } from '../components/IconWrapper';
import { Row } from '../components/Row';
import { useOrderFormStyles } from '../components/styles';

export const CustomerMobileRow = memo(
  ({ required, ...props }: { required?: boolean; disabled?: boolean }) => {
    const {
      theme,
      mode,
      formController: { form },
    } = useOrderFlowContext();

    const { iconColor, placeholderColor } = theme;

    const styles = useOrderFormStyles();
    const { rpx } = useResponsiveContext();
    const permissions = useUserPermissions();
    const canDialCustomer = permissions?.dialCustomer;
    const [focused, setFocused] = useState(false);
    const hasChanged = useRef(false);
    const originalValue = useRef('');
    const onFocused = usePersistFn(() => {
      if (!focused) {
        setFocused(true);
        if (!canDialCustomer) {
          originalValue.current = form.customerMobile.value ?? '';
          form.customerMobile.update('');
        }
      }
    });

    return (
      <Row
        errorProp="customerMobile"
        icon={
          <IconWrapper>
            <Icon name="mobile-phone" color={iconColor} size={rpx(20)} />
          </IconWrapper>
        }
        {...props}
      >
        <Cell label="联系方式" required={required}>
          <Input
            style={styles.formInput}
            placeholderTextColor={placeholderColor}
            value={
              mode === 'update' &&
              form.customerMobile.value &&
              !focused &&
              !canDialCustomer
                ? maskedMobilePhone(form.customerMobile.value)
                : form.customerMobile.value
            }
            keyboardType="number-pad"
            placeholder="请输入车主手机号码"
            clearButtonMode="while-editing"
            errorMsg={form.customerMobile.error}
            loading={form.customerMobile.loading}
            editable={!props.disabled}
            onFocus={onFocused}
            onBlur={() => {
              form.customerMobile.onBlur();
              if (
                mode === 'update' &&
                focused &&
                !canDialCustomer &&
                !hasChanged.current
              ) {
                form.customerMobile.reset();
                setFocused(false);
              }
            }}
            onChangeText={value => {
              hasChanged.current = true;
              form.customerMobile.update(value.replace(/\s/g, ''));
            }}
          />
        </Cell>
      </Row>
    );
  },
);
